/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import LoadingSkeleton from 'bundles/grading/components/common/LoadingSkeleton';

const styles = {
  rightContainer: css`
    display: flex;
    align-items: center;
    margin-right: var(--cds-spacing-100);
  `,
};

// Component for Top Bar sub components for SGA
const LazyLoadRight = () => {
  return <LoadingSkeleton width="33vw" height="30px" cssOverride={styles.rightContainer} />;
};

export default LazyLoadRight;
